"use client";
import { getAdminDemoSongActions } from "./getAdminDemoSongActions";
import { getAdminOrderSongActions } from "./getAdminOrderSongActions";
import { getCustomerSongActions } from "./getCustomerSongActions";
import { getPublicDemoSongActions } from "./getPublicDemoSongActions";
import type { GetSongActions } from "./songActions.types";


export type ActionsVariant =
  | "customer-order"
  | "admin-order"
  | "public-demo"
  | "admin-demo";

const actionFactories: Record<ActionsVariant, GetSongActions> = {
  "customer-order": getCustomerSongActions,
  "admin-order": getAdminOrderSongActions,
  "public-demo": getPublicDemoSongActions,
  "admin-demo": getAdminDemoSongActions,
};

export const getActionsFactory = (
  variant?: ActionsVariant,
): GetSongActions | undefined => {
  if (!variant) return undefined;
  return actionFactories[variant];
};

export default actionFactories;
